import React, { Component } from 'react';
import { Menu, Header, Segment, Form, Grid, Button } from 'semantic-ui-react';
import { BaseURLDev, headers } from '../../../../../_utils/config';
import loader from '../../../../../loader.gif'
import swal from 'sweetalert';

export default class Setting extends Component {
   constructor(props){
      super(props);
      this.state = {
        files: [],
        loading: false
      }
   }


    onCheckTask(task_id){
      fetch(`${BaseURLDev}/celery/status?id=${task_id}`, { 
        method: 'GET',
        // body: JSON.stringify(this.state.files),
        headers,
      })
      .then(response => {
          if(!response.ok){
            swal("Error", 'Update data STS gagal', "error");
            return Promise.reject(response.statusText);
          }
          return response.json()
      })
      .then(resJSON => {
        if(resJSON.other == null){
          this.onCheckTask(task_id)
        }
        else{
          this.setState({ loading: false })
          swal("Import rekening telah selesai", "success");
          return false
        }
      })
    }

   onSubmit(){
     this.setState({ loading: true })
        if(this.state.files.length != 0)
        {
            fetch(`${BaseURLDev}/setup/import`, { 
                method: 'POST',
                body: JSON.stringify(this.state.files),
                headers,
            })
            .then(response => {
                if(!response.ok){
                   swal('', 'Import rekening gagal', "error").then(() => {
                    this.setState({ loading: false })
                    window.location.href = '/a/setting'
                   })
                   return Promise.reject(response.statusText);
                }
                return response.json()
            })
            .then(resJSON => {
              this.setState({ loading: false })
              swal('', 'Import rekening telah selesai', "success").then(() => {
                window.location.href = '/a/setting'
              })
            })
        }else{
          swal('','file excel belum dilampirkan', 'error')
          return false
        }
   }

  //  loadingFile(){
  //     swal('','Tunggu Sebentar....', 'warning')
  //  }

   handleChange(e) {

    this.setState({ loading: true })
    // get the files
    let files = e.target.files;

    // Process each file
    var allFiles = [];
    for (var i = 0; i < files.length; i++) {

      let file = files[i];

      // Make new FileReader
      let reader = new FileReader();

      // Convert the file to base64 text
      reader.readAsDataURL(file);

      // on reader load somthing...
      reader.onload = () => {

        // Make a fileInfo Object
        let fileInfo = {
          name: file.name,
          type: file.type,
          size: Math.round(file.size / 1000) + ' kB',
          base64: reader.result,
          file: file,
        };

        // Push it to the state
        allFiles.push(fileInfo);

        // If all files have been proceed
        if(allFiles.length === files.length){
          // Apply Callback function
          if(this.props.multiple)
            this.setState({ files: allFiles });
          else this.setState({ files: allFiles[0] });
        }

      } // reader.onload

    } // for
    this.setState({ loading: false })

  }
   render() {
      return (
        <div>
            <Menu>
                <Menu.Item>
                <Header>Setting Import Rekening</Header>
                </Menu.Item>
            </Menu>
            <Grid>
                <Grid.Column width={4}>
                { this.state.loading &&
                <div id="loading">
                      <center>
                      <p><img id="img" src={ loader } style={{"marginTop":"20%", "width": "80px", "height": "80px"}} /></p>
                          <div>
                            <p style={{"color": "white", "fontSize": "18px", "fontWeight": "bold"}}>Tunggu sebentar...</p>
                            {/* <p id="content" style="color:white; font-size: 18px; font-weight:bold">Tunggu sebentar...</p>
                            <p id="content_link" style="display: none; color:white; font-size: 18px; "></p>
                            <a href="#" id="tutup" style="display: none; font-size: 18px; ">Tutup</a> */}
                          </div>
                      </center>
                  </div>
                }
                    <Segment color='violet'>
                        <input
                            type="file"
                            onChange={ this.handleChange.bind(this) }
                            // multiple={ this.props.multiple } 
                            accept=".xls,.xlsx"
                        /><br /><br />
                        <Button positive onClick={ this.onSubmit.bind(this) }>
                            Proses
                        </Button>
                    </Segment>
                </Grid.Column>
            </Grid>
         </div>
      );
   }
}


// WEBPACK FOOTER //
// ./src/components/Content/views/admin/setting/Setting.js